import { combineEpics, type Epic } from 'redux-observable';
import { filter, map } from 'rxjs';
import { editMatch, localUpdateMatch } from '../actions';

const editMatchEpic: Epic = (action$) =>
  action$.pipe(
    filter(editMatch.match),
    map(({ payload }) => localUpdateMatch(payload)),
  );

export default combineEpics(editMatchEpic);
